<template>
  <div>
    <b-modal
      id="view-modal-contract-duplicate"
      hide-footer
      no-close-on-backdrop
      size="md"
      modal-class="modern-modal"
      @shown="onModalOpened"
      @hidden="onModalClosed"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-clone mr-2"></i>

          Duplicar Contrato
        </div>
      </template>

      <div v-if="contract_id && contract_name">
        <div class="form-group">
          <LabelRequiredField label="Selecione os usuários" />
          <div class="select-wrapper">
            <v-select
              v-model="residents_ids"
              :items="residents"
              item-text="name"
              item-value="id"
              multiple
              clearable
              ref="userSelect"
              outlined
              hide-details
              class="modern-select"
              placeholder="Selecione os usuários"
              @change="closeSelectResident"
            />
          </div>
        </div>

        <div v-if="errors.length > 0">
          <ErrorsMessages :errors="errors" />
        </div>

        <div class="row justify-content-end no-gap">
          <v-btn class="duplicate-btn mr-1" @click="duplicateContract()">
            <i class="fas fa-clone mr-1"></i>
            Duplicar Contrato
          </v-btn>
        </div>
      </div>

      <div v-else>
        <p>Informações não encontradas</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import LabelRequiredField from "../Components/LabelRequiredField";

import toast from "../../lib/ToastNotification";

import api from "../../services/api";

import ErrorsMessages from "../../templates/Components/ErrorsMessages";

export default {
  name: "DuplicateModal",

  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  props: {
    contract_id: {
      type: Number,
      default: null,
    },

    contract_name: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      loading: false,

      residents: [],

      residents_ids: [],

      errors: [],
    };
  },

  watch: {
    async contract_id() {
      await this.getResidents();
    },
  },

  methods: {
    async getResidents() {
      try {
        this.loading = true;

        let params = { status_resident: "ATIVO" };

        const response = await api.get("/rest-home/residents", { params });

        const { error, residents } = response.data;

        if (!error) {
          this.residents = residents;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async duplicateContract() {
      try {
        this.loading = true;

        const { contract_id, contract_name, residents_ids } = this;

        let params = {
          contract_id,
          contract_name,
          residents_ids,
        };

        const response = await api.post("/contract-duplicate", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("view-modal-contract-duplicate");

          this.errors = [];

          toast(message, "success");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async onModalOpened() {
      await this.getResidents();
    },

    closeSelectResident() {
      this.$refs.userSelect.blur();
    },

    onModalClosed() {
      this.residents = [];

      this.residents_ids = [];

      this.errors = [];
    },
  },
};
</script>

<style scoped>
.duplicate-btn {
  background: linear-gradient(135deg, #f59e42 0%, #ea580c 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(245, 158, 66, 0.3) !important;
  transition: all 0.3s ease !important;
}

.duplicate-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(245, 158, 66, 0.4) !important;
}
</style>